import axios from "axios";

// Create Axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // Uses your .env variable
  headers: {
    "Content-Type": "application/json",
  },
});

// **Attach token automatically to every request**
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

export default api;